import { Observable } from "core/Misc/observable";
export class StateManager {
    constructor() {
        this.onSearchBoxRequiredObservable = new Observable();
        this.onSelectionChangedObservable = new Observable();
        this.onFrameCreatedObservable = new Observable();
        this.onUpdateRequiredObservable = new Observable();
        this.onGraphNodeRemovalObservable = new Observable();
        this.onSelectionBoxMoved = new Observable();
        this.onCandidateLinkMoved = new Observable();
        this.onCandidatePortSelectedObservable = new Observable();
        /** The source port data for the current drag operation, used for design-time compatibility checks */
        this.candidateSourcePortData = null;
        /** When true, ports glow red during drag when hovering over an incompatible target. Default false. */
        this.enablePortCompatibilityHighlight = false;
        /** When true, nodes can display validation and breakpoint badge overlays. Default false. */
        this.enableNodeBadges = false;
        this.onNewNodeCreatedObservable = new Observable();
        this.onRebuildRequiredObservable = new Observable();
        this.onNodeMovedObservable = new Observable();
        this.onErrorMessageDialogRequiredObservable = new Observable();
        this.onExposePortOnFrameObservable = new Observable();
        this.onGridSizeChanged = new Observable();
        this.onNewBlockRequiredObservable = new Observable();
        this.onHighlightNodeObservable = new Observable();
        this.onPreviewCommandActivated = new Observable();
    }
    queueRebuildCommand() {
        if (this._isRebuildQueued) {
            return;
        }
        this._isRebuildQueued = true;
        setTimeout(() => {
            this.onRebuildRequiredObservable.notifyObservers();
            this._isRebuildQueued = false;
        }, 1);
    }
}
//# sourceMappingURL=stateManager.js.map